import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-top",
  "use": "icon-arrow-top-usage",
  "viewBox": "0 0 16 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 10\" id=\"icon-arrow-top\"><path d=\"M15.834 8.873c.11.129.166.29.166.467a.702.702 0 0 1-.166.466.51.51 0 0 1-.801 0L7.99 1.595.948 9.806a.51.51 0 0 1-.8 0 .74.74 0 0 1 0-.933L7.59.193a.512.512 0 0 1 .801 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol